import { useSelector } from 'react-redux';

import DeleteFieldset from '@/components/atoms/Fieldset/templates/IntegrationsFieldset/DeleteFieldset';
import { useDeskId } from '@/hooks/useDeskId';
import { useIntegrations } from '@/hooks/useIntegrations';
import { selectIntegrationId } from '@/redux/session/selectors';
import { FacebookError, FacebookIntegration } from '@/shared/types/integration';

import RedirectFieldset from './fieldsets/RedirectFieldset';

interface Props {
  onOAuthClick: () => void;
  previousFBConnection?: string;
  error?: FacebookError;
  isConnecting?: boolean;
}

const FacebookOAuth = ({ onOAuthClick, previousFBConnection, error, isConnecting }: Props) => {
  const deskId = useDeskId();
  const integrationId = useSelector(selectIntegrationId);
  const { integration } = useIntegrations<FacebookIntegration>(deskId, integrationId);

  return (
    <div className="flex flex-col gap-4">
      <RedirectFieldset
        onOAuthClick={onOAuthClick}
        type={integration?.type}
        error={error}
        previousFBConnection={previousFBConnection}
        isConnecting={isConnecting}
      />
      <DeleteFieldset integration={integration} />
    </div>
  );
};

export default FacebookOAuth;
